import { render, staticRenderFns } from "./javaUploadFile.vue?vue&type=template&id=9b1afb5e&scoped=true&"
import script from "./javaUploadFile.vue?vue&type=script&lang=ts&"
export * from "./javaUploadFile.vue?vue&type=script&lang=ts&"
import style0 from "./javaUploadFile.vue?vue&type=style&index=0&id=9b1afb5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1afb5e",
  null
  
)

export default component.exports